/**
 * @desc 冻结
 */
const URL = "/rantion-stock";
import http, { updateResponse } from "@/http";
export function request(body: defs.stock.StockOrderFreezeCmd, options?: any) {
  return updateResponse(
    http(URL + `/stock/freeze`, {
      method: "POST",

      data: body,
      ...options,
    }),
  );
}
